export default "__VITE_PUBLIC_ASSET__ff6f9a60__"